import 'jquery-ui'
import 'jquery-ui/ui/widgets/resizable.js'
import 'jquery-ui/ui/widgets/sortable.js'
import focus from '@alpinejs/focus'
import ace from 'ace-builds/src-min-noconflict/ace.js'
import Alpine from 'alpinejs'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light-border.css'
// import './_elis/resizer'
import './component/treeSelect/index.tsx'
import './component/profiler/index.tsx'
import { App } from 'app/index.ts'
import { Loader } from 'component/index.ts'
import fineUploader from 'fine-uploader/lib/jquery/traditional.js'
import $ from 'jquery'
import Cookies from 'js-cookie'
import spectrum from 'spectrum-colorpicker2'
import Swal from 'sweetalert2'

import * as appFunctions from './_elis/$_functions.js'
import { client } from './_elis/client.js'
import * as mentions from './_elis/mentionTextarea.js'
import { resizetrigger } from './_elis/resizer.js'
import * as responsiveMenu from './_elis/responsive_menu.js'
import { number } from './utils/index.ts'

if ($) {
	$.extend({ spectrum })
	$.extend({ fineUploader })
}

window.jQuery = $
window.$ = $
window.Cookies = Cookies

Alpine.plugin(focus)
window.Alpine = Alpine

// Nette Forms
// window.Nette = Nette // přidáno do layout jako link na www jinak nefunguje toggle ve fromulářích

// Settings
window.blockAttributeData = {}

// Ace
window.ace = ace

// App functions
window.show = appFunctions.show
window.debounce = appFunctions.debounce
window.makeDebounceAjaxCall = appFunctions.makeDebounceAjaxCall
window.resizetrigger = resizetrigger
window.Loader = Loader
// Responsive menu
window.app = responsiveMenu.app

window.formatNumber = number.formatNumber

window.mentionTextArea = mentions.mentionTextArea
window.mentionHighlight = mentions.mentionHighlight

// Src export
window.Swal = Swal

/**
 * Create new ELIS scripts instance -> Init
 */
try {
	client()
	const app = App()
	app.init()
} catch (e) {
	throw Error(e)
}
